<template>
    <b-modal
        v-on:ok="pickAssets"
        v-on:cancel="closeModal"
        v-on:hide="$emit('close')"
        :visible="show"
        body-class="p-0"
        modal-class="asset-modal"
        size="xl" title="Asset Manager">
        <p v-if="initialized">Loading...</p>
        <div v-else>
            <file-manager-component
                v-on:fm::asset::select="selectAsset"
                v-on:fm::asset::dblclick="getAsset"
                :getData="getData"
                :replaceData="replaceData"
                :createData="modifiedCreateData"
                :updateBatch="modifiedUpdateBatch"
                :addNotification="addNotification"
                :content="content"
                :timestamp="timestamp"
                :currentValue="value"
                :allowedExtensions="extensions"
                :multiple="multiple"
                :storagePanel="storagePanel"
                :storages="storages"
                :embedded="true"
                :hide="!show"
                ></file-manager-component>
        </div>
    </b-modal>
</template>
<script>
import Vue from 'vue';
import Vuex from 'vuex';
import FileManagerComponent from '../AssetManagerComponent';

export default {
    data() {
        return {
            asset: null,
        }
    },

    components: {
        FileManagerComponent,
    },

    props: ['value', 'show', 'closeModal', 'extensions', 'multiple', 'storagePanel', 'storages'],

    watch: {
        timestamp(ts) {
            this.$forceUpdate();
        },
    },

    mounted() {
        if (!this.content && !this.loading) {
            this.getData();
        }
    },

    computed: {
        ...Vuex.mapGetters('assets', {
            content: 'content',
            loading: 'loading',
            timestamp: 'timestamp',
            fileModalOpen: 'fileModalOpen',
        }),

        initialized() {
            return !this.content;
        },
    },

    methods: {
        ...Vuex.mapActions('assets', {
            getData: 'getData',
            createData: 'createData',
            updateBatch: 'updateBatch',
            replaceData: 'replaceData',
            addNotification: 'addNotification',
        }),

        // modify top level API methods so that
        // they accept multiple arguments instead of just 1
        modifiedCreateData(data, options) {
            return this.createData({ data, options });
        },

        modifiedUpdateData(data, options) {
            return this.updateData({ data, options });
        },

        modifiedUpdateBatch(data, options) {
            return this.updateBatch({ data, options });
        },

        selectAsset(asset) {
            this.asset = asset;
        },

        getAsset(asset) {
            this.$emit('change', asset);
        },

        pickAssets() {
            this.$emit('change', this.asset);
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/FileModalComponent.vue